export function exportToCSV(data: any[], filename: string) {
  // Get headers from the first object
  if (data.length === 0) return

  const headers = Object.keys(data[0])
  const csvContent = [
    // Headers row
    headers.join(','),
    // Data rows
    ...data.map((row) =>
      headers
        .map((header) => {
          const cell = row[header]
          // Handle strings with commas or quotes
          if (typeof cell === 'string') {
            return `"${cell.replace(/"/g, '""')}"`
          }
          return cell
        })
        .join(','),
    ),
  ].join('\n')

  // Create blob and download link
  const blob = new Blob([`\uFEFF${csvContent}`], {
    type: 'text/csv;charset=utf-8;',
  })
  const link = document.createElement('a')
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}
